// API endpoint constants
export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const LOGIN_API = `${BASE_URL}/login`;
export const REGISTER_API = `${BASE_URL}/register`;
export const API_BASE_URL = "https://mpsreg-api.azurewebsites.net";
export const API_BASE_URL_STAGING = "https://q2rnqc2k-3003.aue.devtunnels.ms";

